import { useTranslation } from 'react-i18next';

import { Button } from './Button';
import { LanguageSwitcher } from './LanguageSwitcher';
import styles from './Header.module.css';

interface HeaderProps {
  onOpenBilling: () => void;
  onOpenFaq: () => void;
  onOpenSettings: () => void;
}

// PARA-105 §6 — персистентный элемент шапки на всех экранах после Splash/AuthError.
// PARA-131 (AC-1, AD-7) — точка входа в раздел подписки: компактная
// иконка-кнопка справа, в ряду с LanguageSwitcher. Текстовая ссылка не
// поместилась бы на узких экранах при длинных локалях (be/de), поэтому
// доступное имя приходит из aria-label словаря. Разрешение конфликтов со
// стеком экранов — забота AppShell, Header про стек не знает.
// PARA-136 — точка входа в настройки вечернего напоминания.
export function Header({ onOpenBilling, onOpenFaq, onOpenSettings }: HeaderProps): JSX.Element {
  const { t } = useTranslation('common');

  return (
    <header className={styles.header}>
      <span className={styles.title}>{t('appTitle')}</span>
      <div className={styles.actions}>
        {/* PARA-133 (AC-1) — точка входа в справку. Первой в группе: справка
            нужна раньше подписки тому, кто ещё разбирается в приложении.
            Глиф — декоративный, доступное имя приходит из словаря (AC-10). */}
        <Button
          variant="ghost"
          className={styles.faqButton}
          aria-label={t('faqEntry')}
          onClick={onOpenFaq}
        >
          <span aria-hidden="true">?</span>
        </Button>
        <Button
          variant="ghost"
          className={styles.billingButton}
          aria-label={t('billingEntry')}
          onClick={onOpenBilling}
        >
          <span aria-hidden="true">★</span>
        </Button>
        <Button
          variant="ghost"
          className={styles.settingsButton}
          aria-label={t('settingsEntry')}
          onClick={onOpenSettings}
        >
          <span aria-hidden="true">⚙</span>
        </Button>
        <LanguageSwitcher />
      </div>
    </header>
  );
}
